<template lang="html">
    <div class="me-index">
        <!--    <van-nav-bar title="课程详情" left-text="返回" left-arrow :fixed="true" @click-left="$router.back()"/>-->
        <van-card class="user-card">
            <template #desc>
                <div class="course-desc">
                    <van-swipe :autoplay="3000">
                        <van-swipe-item v-for="(item,index) in coverUrlArray" :key="index">
                            <img :src="item" style="width: 100%;max-height: 5rem;">
                        </van-swipe-item>
                    </van-swipe>
                    <div style="padding: 0.26667rem 0.42667rem;">
                        <h5 style="font-size: .45rem; margin: 0; font-weight: bold; ">{{ actData.name }}</h5>
                        <div style="padding: 10px 0; color: #1118;">
                            <span class="divider-tag divider-right">结束时间：{{ actData.endTime }}</span>
                           <span class="divider-tag divider-right"><span style="color: #F53F05; font-size:0.38rem; ">{{actData.spellRecordCount}}</span>人已参与拼团</span>
                        </div>
                        <div>
                            <span style="color: #F53F05; font-size:0.55rem; margin-right: 10px; ">¥{{actData.actPrice > 0 ? actData.actPrice : '0'}}</span>
                            <span style="color: #3339; font-size:0.35rem;text-decoration: line-through; ">¥{{ courseData.crossedAmount }}</span>
<!--                            <span class="divider-tag "></span>-->
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <van-tabs @click="onClick" sticky title-active-color="#0091AC" swipeable animated background="#F5F6F7"
                          offset-top="1.22667rem">
                    <van-tab title="参与拼团" title-style="font-size:.4rem;">
                        <div class="course-videos">
                            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                                <van-sidebar v-model="activeKey" style="padding: 0rem 0.42667rem; width: 100%;"
                                             class="custom-subtitle">
                                    <van-sidebar-item title="可直接参与列表拼团"/>
                                </van-sidebar>
                                <van-list
                                        v-model="loading"
                                        :finished="finished"
                                        finished-text="没有更多了">
                                    <van-cell v-for="item in spellGroupList" :key="item">
                                        <van-card class="videos-card">
                                            <template #thumb style="border-radius:0px;">
                                                <van-goods-action-button
                                                        type="danger"
                                                        text="去拼团"
                                                        :to="{ path: `/wechat/act/1/apply?applyType=join&spellGroupId=${item.id}&activityId=${activityId}&courseId=${courseId}&recommendId=${recommendId}&recommendType=${recommendType}`}" />
                                            </template>
                                            <template #desc>
                                                <div style="font-size: 0.4rem;font-weight: bold;"> 还差<span style="color: #F53F05; font-size:0.45rem; ">{{ actData.spellQty-item.spelledCount }}人</span>拼成
                                                </div>
                                                <div style="color: rgba(17,17,17,0.91);">
                                                    <span class="divider-tag divider-right">{{ item.creatorName }}({{ item.creatorAccount }})发起</span>
                                                </div>
                                            </template>
                                        </van-card>
                                    </van-cell>
                                </van-list>

                            </van-pull-refresh>
                        </div>
                    </van-tab>

                    <van-tab title="活动详情" title-style="font-size:.4rem;">
                        <div style="padding: 0rem 0.42667rem;">
                            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

                                <van-sidebar v-model="activeKey" style="width: 100%;" class="custom-subtitle">
                                    <van-sidebar-item title="活动详情"/>
                                </van-sidebar>
                                <div style="text-align: left;  font-size: .4rem;">
                                    <p v-html="actData.shareContent"></p>
                                </div>
                            </van-pull-refresh>
                        </div>
                    </van-tab>
                </van-tabs>

            </template>
        </van-card>
        <div style="height: 1.5rem;"></div>
        <van-goods-action style="">
            <!--            <van-goods-action-icon style="min-width:3rem;" :icon="require('@/assets/classroom.png')" text="课堂"/>-->
            <van-goods-action-button
                    type="warm"
                    text="直接报名"
                    :to="{ path: `/wechat/course/1/apply?courseId=${courseId}&recommendId=${recommendId}&recommendType=${recommendType}`}" />
            <van-goods-action-button
                    type="danger"
                    text="发起拼团"
                    :to="{ path: `/wechat/act/1/apply?applyType=launch&activityId=${activityId}&courseId=${courseId}&recommendId=${recommendId}&recommendType=${recommendType}`}" />
        </van-goods-action>
    </div>
</template>

<script>
    import website from "../../utils/website";
    import wx from "weixin-js-sdk";

    export default {
        data() {
            return {
                spellGroupList: [],
                spellGroupSize: 1,
                actData: {},
                courseData: {},
                loading: false,
                finished: false,
                isLoading: false,
                activityId: '',
                courseId: '',
                recommendId: '',
                recommendType: '',
                searchKey: "",
                activeKey: 0,
                activeName: 0,
                commentData: [],
                commendData: [],
                coverUrlArray: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                const activityId = this.$router.history.current.params.id;
                this.activityId = activityId;
                this.user = window.localStorage.getItem('user');
                if (this.user){
                    this.user = JSON.parse(this.user);
                }
                this.recommendId = this.$router.history.current.query.recommendId;
                this.recommendType = this.$router.history.current.query.recommendType;
                if (!this.recommendId && !this.recommendType && this.user){
                    this.recommendId = this.user.user_id;
                    this.recommendType = window.localStorage.getItem('roleName');
                }
                this.$api.activity.getActivitySpellDetail({
                    id: activityId
                }).then((res) => {
                    this.isLoading = false;
                    if (res.code === 200) {
                        this.actData = res.data;
                        console.log(this.actData);
                        window.document.title = this.actData.name;
                        this.coverUrlArray = res.data.sharePic.split(',');
                        this.courseData = this.actData.courseInfoList[0];
                        this.courseId = this.courseData.id;
                        this.finished = true;
                        this.share();
                    } else {
                        this.$notify({type: 'danger', message: res.msg})
                    }
                });
                //获取已发起的拼团列表
                this.getActivitySpellGroupList();
                //====todo:保存活动查看记录
                /*this.$api.activity.saveActivityView({
                    activityId: activityId
                });*/
            },
            onRefresh() {
                setTimeout(() => {
                    this.isLoading = false;
                }, 1000);
            },
            onClick(name, title) {
                console.log('click tab', name, title);
                switch (title) {
                    case '参与拼团':
                        this.getActivitySpellGroupList();
                        break;
                }
            },
            getActivitySpellGroupList() {
                this.$api.activity.getActivitySpellGroupList({
                    activityId: this.activityId
                }).then((res) => {
                    if (res.code === 200) {
                        this.spellGroupList = res.data;
                        console.log(this.spellGroupList);
                        this.spellGroupSize = this.spellGroupList.length;
                    }
                })
            },
            share() {
                const that = this;
                this.isLoading = true;
                const shareUserUrl = website.domain + `/wechat/spellinfo/${this.activityId}?recommendId=${this.recommendId}&recommendType=${this.recommendType}&shareType=actShare`;
                this.$api.wechat.getShareSignature({
                    appid: website.appid,
                    shareUrl: website.domain + this.$route.fullPath,
                }).then((res) => {
                    this.isLoading = false;
                    const shareSign = res.data;
                    wx.config({
                        debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: shareSign.appId,         // 必填，公众号的唯一标识，填自己的！
                        timestamp: shareSign.wxTimestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                        nonceStr: shareSign.wxNoncestr,   // 必填，生成签名的随机串
                        signature: shareSign.wxSignature, // 必填，签名，见附录1
                        jsApiList: [
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                        ]
                    })
                    wx.checkJsApi({
                        jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                        success: function (res) {
                            // 以键值对的形式返回，可用的api值true，不可用为false
                            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                            console.log('check jsapi res: ', res);
                        }
                    });
                    const userName = that.user ? that.user.nick_name : '';
                    wx.ready(function () {
                        //分享到朋友圈
                        wx.updateTimelineShareData({
                            title: '【' + that.actData.name + '】活动课程：' + that.courseData.name,   // 分享时的标题
                            link: shareUserUrl,     // 分享时的链接
                            imgUrl: that.courseData.thumbUrl,    // 分享时的图标
                            success: function () {
                                // that.$notify({type:'success',message:'分享朋友圈配置成功'});
                                // that.$api.consultant.saveShareCount({consultantId: that.consultantInfo.id})
                            },
                            // fail: function (res) {
                            // console.log(res)
                            // that.$notify({type: 'warning', message: '取消分享' });
                            // }
                        });
                        //分享给朋友
                        wx.updateAppMessageShareData({
                            title: '【' + that.actData.name + '】活动课程：' + that.courseData.name,   // 分享时的标题
                            link: shareUserUrl,     // 分享时的链接
                            imgUrl: that.courseData.thumbUrl,    // 分享时的图标
                            desc: `${userName}向您推荐优秀课程`,
                            type: '',
                            dataUrl: '',
                            success: function () {
                                // that.$notify({type:'success',message:'分享朋友配置成功'});
                                // that.$api.consultant.saveShareCount({consultantId: that.consultantInfo.id})
                            },
                            // fail: function (res) {
                            // console.log(res)
                            // that.$notify({type: 'warning', message: '取消分享' });
                            // }
                        });
                    })
                    wx.error(function (res) {
                        console.log('wx error  ', res)
                    })
                })
            },
        }
    }
</script>

<style lang="less" scoped>

    .divider-tag {
        padding-right: 8px;
        margin-right: 8px;
        position: relative;
    }

    [class*='divider-right']::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border-right: 1px solid #aaa8;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
    }

    .user-card {
        padding: 0px;
        background: #fff;
    }

    .van-card__header {
    }

    .user-card .van-card__footer {
        text-align: left;
    }

    .user-card .van-card__thumb {
        width: 38%;
        max-width: 150px;
        height: auto;
    }

    .list-card {
        padding: 0;
        background: #fff;
    }


    .list-card .van-card__header {
        padding: 0px;
    }

    .list-card .van-card__thumb {
        width: 18vw;
        max-width: 150px;
        height: auto;
    }

    .course-info--ellipse {
        background-color: #fff;
        padding: 0;
    }

    .course-info--ellipse .van-card__thumb {
        width: 16vw;
        max-width: 150px;
        height: auto;
    }


    .videos-card {
        padding: 0;
        background: #fff;
    }

    .videos-card .van-card__header {
        padding: 0px;
    }

    .videos-card .van-card__thumb {
        width: 24vw;
        max-width: 150px;
        height: auto;
    }

    /*购物车按钮*/
    .van-goods-action-button--warm {
        background: -webkit-linear-gradient(left, #00b1d2, #9be2ef);
        background: linear-gradient(to right, #00b1d2, #9be2ef);
    }

    /*购物车按钮*/
    .van-goods-action-button--danger {
        background: -webkit-linear-gradient(left, #00b1d2, #0091AC);
        background: linear-gradient(to right, #00b1d2, #0091AC);
    }


    .van-card__footer .van-button {
        margin-left: 0;
    }

    .van-sidebar-item {
        padding: 0.5rem 0.32rem;
        font-size: 0.5rem;
    }

    .custom-collapse {
        text-align: center;
    }

    .custom-collapse-item {
        display: inline-block;
        color: #888;
    }


    #container {
        width: 100%;
        z-index: 1;
        min-height: 100vh;

        &:hover {
            cursor: pointer;
        }
    }

    .list-caontainer {
        margin-bottom: 1.2rem;
    }

    .search-icon {
        font-size: .3rem;
        line-height: inherit;
    }

    .van-card__content {
        min-height: 1rem;
    }
</style>
<style>
    .van-cell--clickable:active {
        background-color: #fff;
    }

    .custom-collapse-item .van-cell {
        width: fit-content;
        margin: 0 auto;
    }

    .custom-collapse-item .van-cell__title, .custom-collapse-item .van-cell__right-icon {
        color: #1114;
    }

    .custom-collapse-item .van-cell__right-icon {
    }

    .van-goods-action-icon__icon {
        font-size: 0.5rem;
    }

    .custom-subtitle {
        overflow-y: unset;
    }
</style>
